/* eslint-disable react/jsx-props-no-spreading */
import { FC, ComponentProps } from 'react';
import { Box, Svg } from '@altermaind/web/ui';
import { useCalculateDrawerDynamicWidth } from '@/_shared/hooks/useCalculateDrawerDynamicWidth';
import { useDrawer } from '../Drawer';

type Props = Pick<ReturnType<typeof useDrawer>, 'Drawer' | 'isOpen'> & {
  drawerProps?: Omit<
    ComponentProps<ReturnType<typeof useDrawer>['Drawer']>,
    'Drawer' | 'isOpen' | 'children'
  >;
  /**
   * `children` must be required.
   */
  children?: JSX.Element;
  onClose?: ReturnType<typeof useDrawer>['close'];
};

export const InternalDrawer: FC<Props> = ({ Drawer, drawerProps, isOpen, children, onClose }) => {
  const drawerDynamicWidth = useCalculateDrawerDynamicWidth();

  return (
    isOpen && (
      <Drawer
        {...drawerProps}
        style={{
          overflowY: 'hidden',
          paddingRight: '0px',
          paddingLeft: '0px',
          ...(drawerProps?.style || {}),
        }}
        width={drawerDynamicWidth}
        isOpen={isOpen}
        closeOnClickOutSide={false}
      >
        <Box width='96%' flexDirection='column' display='flex' style={{ margin: '0 auto' }}>
          {onClose && (
            <Box textAlign='right' onClick={onClose} style={{ cursor: 'pointer' }}>
              <Svg name='close' size='s' />
            </Box>
          )}
          {children}
        </Box>
      </Drawer>
    )
  );
};
